<script>
import ConsignacaoDetalhe from '@/components/shared/consignacao/consignacaoDetalhe.vue'

export default {
  extends: ConsignacaoDetalhe,
}
</script>
